<app-loading-spinner [isLoading]="daveningService.loading()"></app-loading-spinner>

<div *ngIf="!responseMessage" class="container">
    <h2>Confirm Delete</h2>
    <p>Are you sure you want to delete this name?</p>
    <button class="btn btn-danger btn-md" id="deleteButton" (click)="confirmDelete()">Yes, please delete</button>
    <button class="btn btn-success btn-md" (click)="cancel()">Cancel</button>
  </div>

  <div class="response" *ngIf="responseMessage" [innerHTML]="responseMessage"></div>
